import request from '/utils/request';
// 地图
export function mapList(params) {
  return request({
    url: '/financeNetworkInfo/search',
    method: 'post',
    params,
  });
}
